import { Swap } from '@app/collections/swap'
import Head from 'next/head'

export default function Frozen() {
  return (
    <>
      <Head>
        <title>Swap - Coast</title>
      </Head>
      <Swap />
    </>
  )
}
